export default __webpack_public_path__ + "./images/gy.3f2204c3.png";